import { BaseData } from '../../../../../../shared/models/base-data';

export class W8BenLandingData extends BaseData {
   
}